import React, { useMemo } from 'react';
import classnames from 'classnames';
import { isNull } from 'lodash';

import DayJs from 'utils/Dayjs';
import { EXAM_STUDENT_STATES } from 'utils/Constants';

import Mark from 'components/Ui/Mark';
import Pill from 'components/Misc/Pill';
import { Title } from 'components/Misc/Typography';
import { Button, Datepicker } from 'components/Misc/Form';

const Take = ({ take }) => {
	// Find status info
	const state = useMemo(() => EXAM_STUDENT_STATES.find(state => state.value === take.state), [take.state]);

	// Get mark's type
	const type = useMemo(() => ({
		unavailable: take.state === 'assigned' || take.state === 'active',
		active: take.state === 'active',
		finished: take.state === 'finished',
		reviewed: take.state === 'reviewed',
		transfered: take.state === 'reviewed' && isNull(take.startedAt),
		overdue: take.state === 'assigned' && DayJs().isAfter(take.endDate),
		failed: take.state === 'reviewed' && take.mark !== 0 && take.mark < 4
	}), [take]);

	// Get mark's style
	const style = classnames(
		type.active && 'text-neutral-700 border-sky-500 dark:text-neutral-200 dark:border-sky-500 after:absolute after:w-5 after:h-5 after:rounded-md after:border after:border-sky-500 after:animate-ping',
		type.finished && 'text-neutral-700 border-amber-500 dark:text-neutral-200 dark:border-amber-500',
		type.reviewed && 'text-neutral-700 border-neutral-200 dark:text-neutral-200 dark:border-neutral-500',
		type.transfered && 'text-neutral-700 border-emerald-500 dark:text-neutral-200 dark:border-emerald-500',
		type.overdue && 'text-rose-500 border-rose-500 dark:text-rose-500 dark:border-rose-500 text-xs',
		type.failed && 'text-rose-500 border-rose-500 dark:text-rose-500 dark:border-rose-500',
		(!type.active && !type.finished && !type.reviewed && !type.transfered && !type.overdue && !type.failed)
		&& 'text-neutral-700 border-neutral-200 dark:text-neutral-200 dark:border-neutral-500'
	);

	return (
		<div key={take?.id} className="flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-y-0">
			<Title
				title={take?.exam?.title}
				className="flex-1"
			/>

			<div className="flex space-x-2">
				<Datepicker
					readOnly
					value={take?.startDate}
				/>

				<Datepicker
					readOnly
					value={take?.endDate}
				/>

				<Pill
					theme={state?.theme}
					name={state?.text}
				/>
			
				<Mark
					type={type}
					mark={type?.overdue ? 'nv' : take?.mark}
					className={style}
				/>
				
				<Button
					small
					square
					icon="link"
					disabled={type.transfered || type.unavailable}
					to={`/exams/results/review/${take?.examId}/${take?.id}`}
				/>
			</div>
		</div>
	);
};

export default Take;